// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host #layoutSidenav_content.scrollable {
  height: calc(100vh - 58px);
  display: block;
  overflow-y: auto;
}`, "",{"version":3,"sources":["webpack://./src/modules/navigation/layouts/layout-dashboard/layout-dashboard.component.scss"],"names":[],"mappings":"AAEA;EACI,0BAAA;EACA,cAAA;EACA,gBAAA;AADJ","sourcesContent":["@import 'styles/core/variables.scss';\n\n:host #layoutSidenav_content.scrollable {\n    height: calc(100vh - 58px);\n    display: block;\n    overflow-y: auto;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
